import { api } from '../lib/api';
import type { PlatformCategory } from '../types/api';

// §21: MSP-Admin-managed platform-wide category list, mirrors the
// site-scoped category API in api/sites.ts but with no org/site in the path.
export async function listPlatformCategories(): Promise<PlatformCategory[]> {
  const { data } = await api.get<PlatformCategory[]>('/platform-categories');
  return data;
}

export async function createPlatformCategory(name: string): Promise<PlatformCategory> {
  const { data } = await api.post<PlatformCategory>('/platform-categories', { name });
  return data;
}

export async function deletePlatformCategory(categoryId: string): Promise<void> {
  await api.delete(`/platform-categories/${categoryId}`);
}
